export const CUSTOMIZE_QUOTE_TEMPLATE = 'customize-quote-template';
export const CUSTOMIZE_QUOTE_THEME_STYLES = 'customize-quote-theme-styles';
export const CREATE_CPQ_QUOTE = 'create-cpq-quote';
export const CREATE_AND_SEND_QUOTE = 'create-and-send-quote';
export const SET_UP_QUOTE_APPROVALS = 'set-up-quote-approvals';
export const CREATE_PRODUCT_V2 = 'create-product-v2';
export const CONFIGURE_CLOSING_AGENT = 'configure-closing-agent';
export const REVIEW_CURRENCY_SETTINGS = 'review-currency-settings';
export const MANAGE_TAX_RATES = 'manage-tax-rates';
export const IMPORT_SYNC_EXISTING_PRODUCTS = 'import-sync-existing-products';